import { Data } from '@blade/std-lib'
import * as UITheme from '@root/shared/ui-kit/theme'

import { ThemeId } from './theme-id'

import type { Theme as DelugeTheme } from '@blade/ui-theme'

export class Theme extends Data.Class<{
  id: ThemeId
  uiTheme: DelugeTheme
}> {}

export const delugeTheme = new Theme({
  id: ThemeId.Deluge,
  uiTheme: UITheme.delugeTheme,
})

export const delugeLightTheme = new Theme({
  id: ThemeId.DelugeLight,
  uiTheme: UITheme.delugeLightTheme,
})

export const testTheme = new Theme({
  id: ThemeId.Test,
  uiTheme: UITheme.testTheme,
})

export const photgoneTheme = new Theme({
  id: ThemeId.Photgone,
  uiTheme: UITheme.photgoneTheme,
})

export const monokaiTheme = new Theme({
  id: ThemeId.Monokai,
  uiTheme: UITheme.monokaiTheme,
})

export const themesMap: Record<ThemeId, Theme> = {
  [ThemeId.Deluge]: delugeTheme,
  [ThemeId.DelugeLight]: delugeLightTheme,
  [ThemeId.Test]: testTheme,
  [ThemeId.Photgone]: photgoneTheme,
  [ThemeId.Monokai]: monokaiTheme,
}

export const availableThemes = [
  delugeTheme,
  delugeLightTheme,
  photgoneTheme,
  monokaiTheme,
  import.meta.env.DEV ? testTheme : undefined,
].filter(Boolean)
